import { useAuth0 } from '@auth0/auth0-react';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { changeTypeOfResource } from 'components/Dashboard/helpers/createTypeOfResource';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';

const useGetFeedItemFlagsForContent = () => {
  const { generalApiCall } = useGeneralApiCall();
  const { isAuthenticated } = useAuth0();

  const getKeywordListId = () => {
    const topicId = getUrlParam('topic-id');
    if (!topicId || topicId === 'all' || topicId === 'none' || isNaN(parseInt(topicId))) {
      return null;
    }
    return parseInt(topicId);
  };

  const getExistingFeedItemFlags = ({ section, idPosition, contentUrl }) => {
    if (idPosition !== null && section?.feedItemFlags?.[idPosition]) {
      return section.feedItemFlags[idPosition];
    }

    if (contentUrl && section?.hits?.length > 0) {
      const index = section.hits.findIndex((item) => item.contentUrl === contentUrl);
      if (index >= 0 && section?.feedItemFlags?.[index]) {
        return section.feedItemFlags[index];
      }
    }

    return null;
  };

  const getFeedItemFlagsForContent = async ({
    id,
    objectId,
    contentUrl,
    sectionName,
    source,
    section,
    idPosition,
  }) => {
    if (!isAuthenticated || !sectionName) {
      return null;
    }

    const existingFeedItemFlags = getExistingFeedItemFlags({ section, idPosition, contentUrl });
    if (existingFeedItemFlags?.relevanceScore !== undefined) {
      return existingFeedItemFlags;
    }

    const keywordListId = getKeywordListId();
    if (!keywordListId) {
      return null;
    }

    const feedType = changeTypeOfResource(sectionName);
    let requestProperties = {
      type: feedType,
      pageSize: 1,
      pageNumber: 1,
      keywordListId,
      includeExplanations: true,
      filters: [],
    };

    if (sectionName === 'ParliamentaryRecord' && contentUrl) {
      requestProperties = {
        ...requestProperties,
        collapseField: 'contentUrl',
        collapseSort: { field: 'contributionOrder', order: 'asc' },
        filters: [{ field: 'contentUrl', value: contentUrl, operator: 'str_eq' }],
      };
    } else if (id) {
      requestProperties.filters = [{ field: 'id', value: `${id}`, operator: 'str_eq' }];
    } else if (objectId) {
      requestProperties.filters = [{ field: 'objectID', value: objectId, operator: 'str_eq' }];
    } else {
      return null;
    }

    const results = await generalApiCall({
      pathname: '/api/feed/query',
      method: 'post',
      requestProperties,
      needsAuthentication: true,
      requestSource: source,
      notShowErrorMessage: true,
    });

    return results?.feedItemFlags?.[0] ?? null;
  };

  return { getFeedItemFlagsForContent };
};

export default useGetFeedItemFlagsForContent;
